import React from "react";
import Header from "./Header";
/* The bottom bar carried only the in-app tabs, which are parked in
   Header.js — restore both together.
import MobileHeader from "./MobileHeader"; */
import HeroBackground from "./HeroBackground";

const Layout = ({ children }) => {
  return (
    /* 100dvh rather than 100vh so mobile browser chrome cannot clip the page */
    <div className="relative w-full max-w-[100vw] h-[100dvh] overflow-hidden layout-bg">
      <div className="h-full overflow-y-auto overflow-x-hidden no-scrollbar">
        <HeroBackground />
        <div className="relative z-10 flex min-h-full flex-col">
          <Header />
          <main className="page-shell flex flex-1 justify-center items-start px-3 sm:px-4 pt-6 sm:pt-10">
            <div className="w-full flex justify-center">{children}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
